<script lang="ts" setup>
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import SupplierForm from '@/components/features/suppliers/SupplierForm.vue'
import { useRouter } from 'vue-router'
import { useSupplierForm } from '@/composables/useSupplierForm'
import { addSupplier } from '@/api/suppliers'
import type { ErrorResponse } from '@/types/error-types'
const {
  values,
  handleSubmit,
  setErrors,
  addressFields,
  newAddress,
  removeAddress,
  showToast,
  loading,
  formType
} = useSupplierForm('add')

const router = useRouter()

const onSubmit = handleSubmit(() => {
  loading.value = true
  const addresses =
    values?.addresses?.map((address: any) => ({
      ...address,
      country: address.country,
      addressType: address.addressType.id
    })) || []

  addSupplier({
    ...values,
    addresses,
  })
    .then(() => {
      loading.value = false
      showToast('success', 'Supplier Added!', 'You have successfully added a new supplier.')
      router.push('/suppliers')
    })
      .catch((error: { response?: { data: ErrorResponse } }) => {
        loading.value = false
        const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to add new supplier.'
        showToast('error', 'An error occurred!', errorMessages)
      })
},
  (errors: Record<string, string>) => {
  loading.value = false

  const errorObjects = Object.entries(errors.errors).map(([field, message]) => ({
    code: field,
    description: message,
  }))

  if(errorObjects.length > 0) {
    const firstError = errorObjects[0]
    const errorMessage = ` ${firstError.description}`
    showToast('error', 'Validation Error', errorMessage)
    return
  }
}
)
</script>

<template>
  <PageHeader
    title="Add a supplier"
    buttonText="Save Supplier"
    buttonIcon="material-symbols:save"
    :buttonClick="onSubmit"
    :loading="loading"
  />
  <div class="bg-white rounded-xl">
    <SupplierForm
      :type="formType"
      :values="values"
      :onSubmit="onSubmit"
      :addressFields="addressFields"
      :newAddress="newAddress"
      :removeAddress="removeAddress"
      :setErrors="setErrors"
      :showToast="showToast"
    />
  </div>
</template>
<style></style>
